import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-star-rating',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss',
})
export class StarRatingComponent implements OnInit{

  @Input() avgRating:any=3.5;
  stars: any;

  ngOnInit() {
    this.generateStarIcons(this.avgRating);
  }

  generateStarIcons(rating: number) {
    this.stars = [];
  
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;
    const totalStars = 5;
  
    for (let i = 0; i < fullStars; i++) {
      this.stars.push('full');
    }
  
    if (hasHalfStar) {
      this.stars.push('half');
    }
  
    while (this.stars.length < totalStars) {
      this.stars.push('empty');
    }
  }

}
